import React from 'react';
import Progress from '@components/Progress';
import {
  Container,
  SoftContainer,
  SoftProgressContainer,
  SoftCompletion,
  SoftScore,
  SoftScoreLabel,
  ProgressLabel,
} from './style';
import { FormattedMessage } from 'react-intl';
import { getStorageAdapter } from '@shell/adapters/storage';
interface Props {
  units: any[];
}

const SoftSkillsProgress: React.FC<Props> = ({ units }) => {
  const allPackages = (units || []).flatMap((u) =>
    (u.packages || []).filter((pkg: any) => pkg.published)
  )
  const total = allPackages.length;
  const completed = allPackages.filter(
    (pkg: any) => (pkg.status || '').toLowerCase() === 'complete'
  ).length;
  const percent = total ? Math.round((completed / total) * 100) : 0;

  return (
    <Container>
      <SoftContainer>
        <SoftProgressContainer>
          <ProgressLabel>
            <FormattedMessage id="Course completion" />
          </ProgressLabel>
          <Progress color="brandSecondary" percent={percent} size="lg" />
        </SoftProgressContainer>
        <SoftCompletion>
          <SoftScore>{percent}%</SoftScore>
          <SoftScoreLabel>
            <FormattedMessage id="completed" />
          </SoftScoreLabel>
        </SoftCompletion>
      </SoftContainer>
    </Container>
  );
};

export default SoftSkillsProgress;
